import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import GeopoliticalMap from '../components/GeopoliticalMap';
import { initFirebase } from '../firebase';

const HeartlandLeaflet = () => {
  const [authStatus, setAuthStatus] = useState('Cargando autenticación...');

  useEffect(() => {
    const init = async () => {
      const uid = await initFirebase();
      if (uid) {
        setAuthStatus(`✅ Conectado`);
      } else {
        setAuthStatus('⚠️ No hay usuario autenticado');
      }
    };
    
    init();
  }, []);

  return (
    <div className="container">
      <Header 
        title="Visualizador: Heartland vs Rimland" 
        subtitle="Mapa Interactivo de Teorías Geopolíticas"
        authStatus={authStatus}
      />

      <section className="card" style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#004e92', marginBottom: '1rem', textAlign: 'center' }}>
          🗺️ Mapa Interactivo: Heartland vs Rimland
        </h2>
        <p style={{ lineHeight: '1.7', marginBottom: '1.5rem', textAlign: 'center', color: '#e2e8f0' }}>
          Visualización geográfica de las teorías del Heartland (Mackinder) y Rimland (Spykman).
        </p>
        <p style={{ lineHeight: '1.7', marginBottom: '1.5rem', textAlign: 'center', color: '#94a3b8', fontSize: '0.9rem' }}>
          💡 Haz clic en las zonas coloreadas para ver más información
        </p>
        
        <GeopoliticalMap />
        
        <div style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem',
          marginTop: '1.5rem'
        }}>
          <div style={{ 
            backgroundColor: 'rgba(239, 68, 68, 0.1)', 
            padding: '0.75rem', 
            borderRadius: '0.5rem',
            borderLeft: '4px solid #ef4444',
            textAlign: 'center'
          }}>
            <span style={{ fontSize: '1.5rem', marginRight: '0.5rem' }}>🔴</span>
            <span style={{ color: '#f8fafc', fontWeight: '600', fontSize: '0.9rem' }}>Heartland</span>
          </div>
          
          <div style={{ 
            backgroundColor: 'rgba(59, 130, 246, 0.1)', 
            padding: '0.75rem', 
            borderRadius: '0.5rem',
            borderLeft: '4px solid #3b82f6',
            textAlign: 'center'
          }}>
            <span style={{ fontSize: '1.5rem', marginRight: '0.5rem' }}>🔵</span>
            <span style={{ color: '#f8fafc', fontWeight: '600', fontSize: '0.9rem' }}>Rimland Europa</span>
          </div>
          
          <div style={{ 
            backgroundColor: 'rgba(234, 179, 8, 0.1)', 
            padding: '0.75rem', 
            borderRadius: '0.5rem',
            borderLeft: '4px solid #eab308',
            textAlign: 'center'
          }}>
            <span style={{ fontSize: '1.5rem', marginRight: '0.5rem' }}>🟡</span>
            <span style={{ color: '#f8fafc', fontWeight: '600', fontSize: '0.9rem' }}>Rimland M. Oriente</span>
          </div>
          
          <div style={{ 
            backgroundColor: 'rgba(139, 92, 246, 0.1)', 
            padding: '0.75rem', 
            borderRadius: '0.5rem',
            borderLeft: '4px solid #8b5cf6',
            textAlign: 'center'
          }}>
            <span style={{ fontSize: '1.5rem', marginRight: '0.5rem' }}>🟣</span>
            <span style={{ color: '#f8fafc', fontWeight: '600', fontSize: '0.9rem' }}>Rimland Asia</span>
          </div>
        </div>
      </section>

      <section className="card">
        <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#004e92', marginBottom: '1rem' }}>
          Leyenda Geopolítica
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(239, 68, 68, 0.1)', borderRadius: '0.5rem', borderLeft: '4px solid #ef4444' }}>
            <h4 style={{ color: '#ef4444', fontWeight: 'bold', marginBottom: '0.5rem' }}>Heartland</h4>
            <p style={{ fontSize: '0.85rem', color: '#cbd5e1' }}>Zona pivote de Eurasia (Rusia, Asia Central)</p>
          </div>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(59, 130, 246, 0.1)', borderRadius: '0.5rem', borderLeft: '4px solid #3b82f6' }}>
            <h4 style={{ color: '#3b82f6', fontWeight: 'bold', marginBottom: '0.5rem' }}>Rimland</h4>
            <p style={{ fontSize: '0.85rem', color: '#cbd5e1' }}>Zonas costeras de Eurasia (Europa, Medio Oriente, Asia)</p>
          </div>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(34, 197, 94, 0.1)', borderRadius: '0.5rem', borderLeft: '4px solid #22c55e' }}>
            <h4 style={{ color: '#22c55e', fontWeight: 'bold', marginBottom: '0.5rem' }}>Anillo Exterior</h4>
            <p style={{ fontSize: '0.85rem', color: '#cbd5e1' }}>Potencias marítimas (América, Japón, Australia)</p>
          </div>
        </div>
      </section>

      <div style={{ position: 'fixed', bottom: '20px', right: '20px', display: 'flex', gap: '10px', zIndex: 1000 }}>
        <Link to="/rimland2" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          ⬅️ Anterior
        </Link>
        <Link to="/" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          🏠 Inicio
        </Link>
      </div>
    </div>
  );
};

export default HeartlandLeaflet;
